<div class="modal-header">
    <h6 class="modal-title pull-left">My Profile</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

       <div class="modal-body">
         <div class="row" >
          <div class="col-md-4 col-sm-4"></div>
          <div class="col-md-4 col-sm-4">
            <div class="container">
              <div class="picture-container">
                  <div class="picture">
                    <div *ngIf="emp_profile!=''">
                      <img class="picture-src" id="wizardPicturePreview" [src]="emp_profile" />
                    </div>
                    <div *ngIf="emp_profile==''">
                      <img src='assets/img/avatar5.png' class="picture-src" id="wizardPicturePreview" title="">
                    </div>
                      <!-- <input type="file" (change)="onSelectFile($event,'Image')" > -->
                      <span class="edit"><i class="fas fa-edit " ></i><input type="file" (change)="onSelectFile($event,'Image')" ></span>
                    </div>
              </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4"></div>
         
         </div>
           <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                    <label for="ID">Name:</label>
                    <input type="text" id="orgname" [(ngModel)]="profile.name"  class="form-control"  >
                </div>
                </div>
                
            <div class="col-md-6 col-sm-12">
                 <div class="form-group">
                      <label for="ID">Email:</label>
                        <input type="email" readonly id="orgname" [(ngModel)]="profile.email"  class="form-control"  >
                    </div>
                 </div>
           </div>
       </div>
       <div class="col text-center">
          <button type="button" class="btn btn-primary btn-default" (click)="update()">Save </button>
        </div>
        <hr>
<div class="modal-header">
          <h6 class="modal-title pull-left">Change Password</h6>
        </div>
      
             <div class="modal-body">
                 <div class="row g-6">
                    <div class="col-md-4 col-sm-12">
                      <div class="form-group">
                          <label for="ID">Old Password:</label>
                          <input type="password"  autocomplete="off" id="orgname" [(ngModel)]="pass.oldPassword"  placeholder="Enter Your Old Password" class="form-control"  >
                      </div>
                      </div>
                      
                  <div class="col-md-4 col-sm-12">
                       <div class="form-group">
                            <label for="ID">New Password:</label>
                              <input type="password" autocomplete="off" id="orgname"  [(ngModel)]="pass.newPassword" placeholder="Enter Your New Password" class="form-control"  >
                          </div>
                       </div>
                  <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                             <label for="ID">Confirm Password:</label>
                               <input type="password" autocomplete="off" id="orgname"  [(ngModel)]="pass.confirmNewPassword" placeholder=" Confirm New Password" class="form-control"  >
                           </div>
                        </div>
                 </div>
             </div>
             <div class="col text-center ">
                <button type="button" class="btn btn-primary btn-default " (click)="updatePassword()" >Change Password </button>
              </div>
              <div class="modal-header">
                
              </div>
    <div class="modal-footer" >
            <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
            </div>
